/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Logs_Risk_Short_MinimalInputs */



/**
* | output |
* | --- |
* | "Minimal" |
*
* @param {Audit_Logs_Risk_Short_MinimalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_logs_risk_short_minimal = /** @type {((inputs?: Audit_Logs_Risk_Short_MinimalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Logs_Risk_Short_MinimalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Minimal")
	return /** @type {LocalizedString} */ ("Minimal")
});